// extracted by mini-css-extract-plugin
export default {"ChatAi":"ChatAi_ChatAi__OfwHE"};